import { QuestionConditionals } from "@/types/crm/configuration/configuration";

export const transformConditionals = (
  conditionals: QuestionConditionals | undefined,
  idMapping: Map<string, string>
): QuestionConditionals | undefined => {
  if (!conditionals) return undefined;

  const transform = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(transform);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          // If the key is a question ID that needs to be mapped, replace it
          const mappedKey = idMapping.get(key) || key;
          return [mappedKey, transform(value)];
        })
      );
    }
    return obj;
  };

  return transform(conditionals);
};